import React from 'react';
import { SignUp as ClerkSignUp } from '@clerk/clerk-react';

function SignUp() {
  return (
    <div style={{
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <ClerkSignUp
        routing="path"
        path="/signup"
        signInUrl="/login"
        appearance={{
          elements: {
            rootBox: { width: '100%', maxWidth: '440px' },
            card: {
              backgroundColor: '#1a1f2e',
              border: '1px solid #2d3748',
              borderRadius: '12px',
              boxShadow: 'none'
            },
            headerTitle: { color: '#ffffff' },
            headerSubtitle: { color: '#a0aec0' },
            formFieldLabel: { color: '#a0aec0' },
            formFieldInput: {
              backgroundColor: '#0f1419',
              border: '1px solid #2d3748',
              color: '#ffffff',
              borderRadius: '8px'
            },
            formButtonPrimary: {
              backgroundColor: '#00d9ff',
              color: '#0a0e1a',
              fontWeight: '700',
              borderRadius: '8px'
            },
            footerActionLink: { color: '#00d9ff' },
            identityPreviewEditButton: { color: '#00d9ff' },
            formFieldInputShowPasswordButton: { color: '#a0aec0' }
          }
        }}
      />
    </div>
  );
}

export default SignUp;
